
(function(){
if(window.__novoraLanding||!document.getElementById('hero'))return;
window.__novoraLanding=true;
/* Theme editor: section HTML is swapped without re-running scripts, so reload the preview to rebuild the 3D scene */
document.addEventListener('shopify:section:load',e=>{if(e.target&&e.target.querySelector&&e.target.querySelector('.novora-landing'))location.reload();});
const $=s=>document.querySelector(s);
const clamp=(v,a=0,b=1)=>Math.min(b,Math.max(a,v));
const lerp=(a,b,t)=>a+(b-a)*t;
const ease=t=>t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2;
const seg=(p,a,b)=>clamp((p-a)/(b-a));
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
const TAU=Math.PI*2;
function progress(el){const r=el.getBoundingClientRect();const tot=r.height-innerHeight;return tot>0?clamp(-r.top/tot):0;}

/* ---------- marquee ---------- */
const rowA=['No sitting on the suitcase','<em>One bag, not two</em>','No hand-rolling','<em>Room for the way home</em>'];
const rowB=['Fill','Pump','Seal','Fly'];
const buildRow=(el,arr)=>{let h='';for(let k=0;k<4;k++)arr.forEach(t=>{h+=t.startsWith('<em>')?t:'<span>'+t+'</span>'});el.innerHTML=h};
buildRow($('#rowA'),rowA);buildRow($('#rowB'),rowB.concat(rowB));

/* ---------- suitcase stack ---------- */
const clothes=[
  {n:'Puffer',f:.34,c:'#1c1b19',t:'#f7f6f3'},
  {n:'Hoodie',f:.25,c:'#8e8a83',t:'#0b0b0a'},
  {n:'Knit',f:.22,c:'#d6ccbc',t:'#0b0b0a'},
  {n:'Jeans',f:.19,c:'#3a3936',t:'#f7f6f3'},
  {n:'Tees ×3',f:.17,c:'#f7f6f3',t:'#0b0b0a'},
  {n:'Towel',f:.17,c:'#b9ae9c',t:'#0b0b0a'}
];
const extras=[{n:'Souvenirs',f:.15,c:'#0b0b0a',t:'#d6ccbc'},{n:'Market finds',f:.12,c:'#c9c2b6',t:'#0b0b0a'}];
const stack=$('#stack');
const layerEls=clothes.concat(extras).map((o,i)=>{const d=document.createElement('div');d.className='layer'+(i>=clothes.length?' drop':'');d.style.background=o.c;d.style.color=o.t;d.innerHTML='<span>'+o.n+'</span>';stack.appendChild(d);return d;});
let caseState=-1;
function updateCase(){
  const p=progress($('#case'));
  const H=$('#caseBox').clientHeight-20, W=$('#caseBox').clientWidth;
  const comp=ease(seg(p,.22,.62));
  const k=lerp(1,.42,comp);
  let total=0;
  clothes.forEach((o,i)=>{const h=o.f*H*k;layerEls[i].style.height=h+'px';layerEls[i].classList.toggle('packed',comp>.05);total+=h+3;});
  extras.forEach((o,j)=>{const el=layerEls[clothes.length+j];const on=p>.74+j*.08;el.style.height=(o.f*H)+'px';el.style.transform=on?'none':'translateY(-'+(H*1.2)+'px)';el.style.opacity=on?1:0;if(on)total+=o.f*H+3;});
  const over=Math.max(0,total-H);
  const ang=Math.atan2(over,W*.92)*180/Math.PI;
  $('#lid').style.transform='rotate('+(-ang).toFixed(2)+'deg)';
  $('#spaceVal').textContent=Math.round(total/H*100)+'%';
  $('#itemVal').textContent=clothes.length+(p>.74?1:0)+(p>.82?1:0);
  const st=p<.22?0:p<.62?1:p<.74?2:3;
  if(st!==caseState){caseState=st;const s=$('#caseStatus');
    s.textContent=['Zip won\'t close','Pumping the air out','Closed. Room to spare.','Closed, with souvenirs.'][st];
    s.style.setProperty('--st',['#b04a3a','#c9a54a','#4f7a52','#4f7a52'][st]);}
}

/* ---------- vacuum-packed type: tracking tightens as headlines rise ---------- */
const squeezers=[...document.querySelectorAll('.squeeze')];
function updateType(){
  const vh=innerHeight;
  $('#heroTitle').style.letterSpacing=(-.045-clamp(scrollY/(vh*.8))*.06).toFixed(4)+'em';
  squeezers.forEach(el=>{const r=el.getBoundingClientRect();const c=(r.top+r.height/2)/vh;const f=ease(clamp((.95-c)/.5));el.style.letterSpacing=(.09-f*.135).toFixed(4)+'em';});
  const x=scrollY*.35;
  $('#rowA').style.transform='translateX('+(-(x%1600))+'px)';
  $('#rowB').style.transform='translateX('+((x%1600)-1600)+'px)';
}

/* ---------- product set (bags S/M/L + pump), drawn from the real product ---------- */
function bagSVG(letter,wcm,hcm){
  const W=100,H=+(100*hcm/wcm).toFixed(1),r=9;
  const x0=7,y0=H*.93,x1=95,y1=H*.08,ang=Math.atan2(y1-y0,x1-x0)*180/Math.PI,len=Math.hypot(x1-x0,y1-y0);
  let ticks='';for(let d=len*.06;d<len*.95;d+=len*.03){const tl=(Math.round(d/(len*.03))%5===0)?2.2:1.1;ticks+='<line x1="'+d.toFixed(1)+'" y1="0" x2="'+d.toFixed(1)+'" y2="'+tl+'"/>';}
  const bs=len*.42,bl=len*.46,bh=12;
  return '<svg viewBox="0 0 '+W+' '+H+'" aria-hidden="true">'+
    '<defs><linearGradient id="sh'+letter+'" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#a7a7a4"/><stop offset=".55" stop-color="#939390"/><stop offset="1" stop-color="#8a8a87"/></linearGradient></defs>'+
    '<path d="M0 '+H+' V'+r+' Q0 0 '+r+' 0 H'+(W-r)+' Q'+W+' 0 '+W+' '+r+' V'+H+' Z" fill="url(#sh'+letter+')"/>'+
    '<rect x="0" y="'+(H*.03).toFixed(1)+'" width="'+W+'" height="'+(H*.018).toFixed(1)+'" fill="#4a4a48"/>'+
    '<g fill="#4f4f4d">'+[0,1,2].map(k=>'<rect x="0" y="'+(H-H*.03-k*H*.016).toFixed(1)+'" width="'+W+'" height=".55"/>').join('')+'</g>'+
    '<g transform="translate('+x0+' '+y0.toFixed(1)+') rotate('+ang.toFixed(2)+')">'+
      '<line x1="0" y1="0" x2="'+len.toFixed(1)+'" y2="0" stroke="#1d1d1c" stroke-width=".6"/>'+
      '<g stroke="#1d1d1c" stroke-width=".35">'+ticks+'</g>'+
      '<path d="M'+bs.toFixed(1)+' 0 H'+(bs+bl-bh*.5).toFixed(1)+' Q'+(bs+bl).toFixed(1)+' 0 '+(bs+bl).toFixed(1)+' '+bh*.5+' V'+bh+' H'+(bs+bh*.2).toFixed(1)+' Q'+(bs-bh*.25).toFixed(1)+' '+bh*.5+' '+bs.toFixed(1)+' 0 Z" fill="#2a2a29"/>'+
      '<text x="'+(bs+bh*.25).toFixed(1)+'" y="'+(bh*.82).toFixed(1)+'" font-family="Inter Tight, Arial, sans-serif" font-weight="700" font-size="'+(bh*.78)+'" fill="#f07a1a">'+letter+'</text>'+
      '<text x="'+(bs+bh*.9).toFixed(1)+'" y="'+(bh*.4).toFixed(1)+'" font-family="Inter Tight, Arial, sans-serif" font-weight="500" font-size="2.5" fill="#f2f2f0" letter-spacing=".1">TRAVEL SET PACKAGE</text>'+
      '<text x="'+(bs+bh*.9).toFixed(1)+'" y="'+(bh*.78).toFixed(1)+'" font-family="Inter Tight, Arial, sans-serif" font-weight="600" font-size="3.2" fill="#f07a1a" letter-spacing=".2">VACUUM STORAGE BAG</text>'+
    '</g>'+
    '<circle cx="50" cy="'+(H*.26).toFixed(1)+'" r="6.2" fill="#4a4a48"/>'+
    '<circle cx="50" cy="'+(H*.26).toFixed(1)+'" r="4.4" fill="none" stroke="#a3a3a0" stroke-width=".7"/>'+
    '<circle cx="50" cy="'+(H*.26).toFixed(1)+'" r="3.4" fill="#232322"/>'+
    '</svg>';
}
function pumpSVG(){
  let ribs='';for(let x=9;x<32;x+=2.6)ribs+='<line x1="'+x.toFixed(1)+'" y1="70" x2="'+x.toFixed(1)+'" y2="110"/>';
  let grooves='';for(let x=5;x<36;x+=2.4)grooves+='<line x1="'+x.toFixed(1)+'" y1="129" x2="'+x.toFixed(1)+'" y2="143"/>';
  return '<svg viewBox="0 0 40 150" aria-hidden="true">'+
    '<defs><linearGradient id="pb" x1="0" x2="1"><stop offset="0" stop-color="#2a2a2a"/><stop offset=".22" stop-color="#151515"/><stop offset=".7" stop-color="#0d0d0d"/><stop offset="1" stop-color="#1e1e1e"/></linearGradient>'+
    '<linearGradient id="pc" x1="0" x2="1"><stop offset="0" stop-color="#f4f3f0"/><stop offset=".6" stop-color="#e6e4df"/><stop offset="1" stop-color="#cfcdc8"/></linearGradient></defs>'+
    '<rect x="6" y="2" width="28" height="112" rx="5" fill="url(#pb)"/>'+
    '<rect x="15" y="4.5" width="10" height="2" rx="1" fill="#3a3a3a"/>'+
    '<g stroke="#050505" stroke-width=".9">'+ribs+'</g>'+
    '<circle cx="20" cy="27" r="6.6" fill="#2a2a2a"/><circle cx="20" cy="27" r="5.6" fill="#dcdbd7"/>'+
    '<g fill="#e8e7e3">'+[0,1,2,3].map(i=>'<circle cx="20" cy="'+(48+i*3.4)+'" r=".8"/>').join('')+'</g>'+
    '<rect x="2" y="111" width="36" height="19" rx="3" fill="#0f0f0f"/><rect x="2" y="111" width="36" height="2.4" rx="1" fill="#2b2b2b"/>'+
    '<rect x="3" y="128" width="34" height="16" rx="2.5" fill="url(#pc)"/>'+
    '<g stroke="#c5c3be" stroke-width=".5">'+grooves+'</g>'+
    '</svg>';
}
const setEl=$('#set');
const setPieces=[...setEl.querySelectorAll('.piece')];
setPieces[0].insertAdjacentHTML('afterbegin',bagSVG('L',54,74));
setPieces[1].insertAdjacentHTML('afterbegin',bagSVG('M',47,64));
setPieces[2].insertAdjacentHTML('afterbegin',bagSVG('S',40,54));
setPieces[3].insertAdjacentHTML('afterbegin',pumpSVG());
const setFrom=setPieces.map(el=>el.dataset.from.split(',').map(Number));
let tilt={x:0,y:0},tiltT={x:0,y:0};
setEl.addEventListener('pointermove',e=>{const r=setEl.getBoundingClientRect();tiltT.x=((e.clientX-r.left)/r.width-.5)*2;tiltT.y=((e.clientY-r.top)/r.height-.5)*2;});
setEl.addEventListener('pointerleave',()=>{tiltT.x=0;tiltT.y=0;});
function updateSet(){
  const r=setEl.getBoundingClientRect(),vh=innerHeight;
  if(r.bottom<-200||r.top>vh+200)return;
  const p=reduce?1:clamp((vh-r.top)/(vh*.75));
  setPieces.forEach((el,i)=>{
    const e=ease(clamp(p*1.25-i*.08));const f=setFrom[i];const z=+el.dataset.z;
    const float=reduce?0:Math.sin(performance.now()/900+i*1.3)*4;
    el.style.transform='translate('+(f[0]*(1-e)).toFixed(2)+'%,'+(f[1]*(1-e)+float*.15).toFixed(2)+'%) rotate('+(f[2]*(1-e)).toFixed(2)+'deg) translateZ('+(z*e).toFixed(1)+'px)';
    el.style.opacity=(.15+.85*e).toFixed(3);
  });
  setEl.classList.toggle('ready',p>.9);
  tilt.x+=(tiltT.x-tilt.x)*.08;tilt.y+=(tiltT.y-tilt.y)*.08;
  const spin=(1-ease(p))*-35;
  setEl.style.transform='rotateY('+(tilt.x*12+spin).toFixed(2)+'deg) rotateX('+(-tilt.y*9+(1-ease(p))*18).toFixed(2)+'deg)';
}

/* ---------- qty ---------- */
let qty=1;const cents=+($('#priceVal').dataset.cents||4999);const fmt=n=>'$'+(n*cents/100).toFixed(2);
const setQ=n=>{qty=clamp(n,1,9);$('#qVal').textContent=qty;$('#priceVal').textContent=fmt(qty);};
$('#qMinus').onclick=()=>setQ(qty-1);$('#qPlus').onclick=()=>setQ(qty+1);
const cartBtn=$('#cartBtn');
if(cartBtn&&cartBtn.dataset.variant){
  cartBtn.addEventListener('click',async()=>{
    const label=cartBtn.textContent;
    cartBtn.disabled=true;cartBtn.textContent='Adding…';
    try{
      const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      const r=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:+cartBtn.dataset.variant,quantity:qty}]})});
      if(!r.ok)throw new Error('add failed');
      const c=await fetch(root+'cart.js').then(x=>x.json()).catch(()=>null);
      if(c&&$('#cartCount'))$('#cartCount').textContent=c.item_count;
      location.href=cartBtn.dataset.next||root+'cart';
    }catch(e){
      cartBtn.disabled=false;cartBtn.textContent='Couldn\'t add it. Try again';
      setTimeout(()=>{cartBtn.textContent=label;},2500);
    }
  });
}

/* ---------- WebGL ---------- */
let renderer=null;
try{ if(!window.THREE) throw 0; renderer=new THREE.WebGLRenderer({canvas:$('#gl'),antialias:true}); }
catch(e){ document.documentElement.classList.add('no-gl'); }

let tick3d=()=>{};
if(renderer){
  const C=h=>new THREE.Color(h).convertSRGBToLinear();
  renderer.setPixelRatio(Math.min(devicePixelRatio,2));
  renderer.outputEncoding=THREE.sRGBEncoding;
  renderer.toneMapping=THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure=1.05;
  const scene=new THREE.Scene();
  const bgInk=new THREE.Color('#0b0b0a'),bgBone=new THREE.Color('#ece9e3');
  scene.background=bgInk.clone();
  const camera=new THREE.PerspectiveCamera(35,1,.1,100);
  camera.position.set(0,0,9);

  scene.add(new THREE.HemisphereLight(0xffffff,0x35332f,.8));
  const key=new THREE.DirectionalLight(0xfff6ea,1.6);key.position.set(4,6,8);scene.add(key);
  const rim=new THREE.DirectionalLight(0xffffff,1.4);rim.position.set(-6,3,-5);scene.add(rim);
  const low=new THREE.DirectionalLight(0xd6ccbc,.5);low.position.set(0,-6,4);scene.add(low);

  const redraws=[];
  function canvasTex(w,h,draw){
    const c=document.createElement('canvas');c.width=w;c.height=h;const x=c.getContext('2d');
    const t=new THREE.CanvasTexture(c);t.encoding=THREE.sRGBEncoding;t.anisotropy=8;
    const run=()=>{x.clearRect(0,0,w,h);draw(x,w,h);t.needsUpdate=true;};run();redraws.push(run);return t;
  }

  /* folded clothes seen through the bag */
  function fabric(seed,pal){
    return canvasTex(256,512,(x)=>{
      let s=seed;const r=()=>(s=(s*16807)%2147483647)/2147483647;
      let y=0;
      while(y<512){
        const h=46+r()*80;x.fillStyle=pal[Math.floor(r()*pal.length)];x.fillRect(0,y,256,h);
        const m=r();
        if(m<.4){x.strokeStyle='rgba(0,0,0,.1)';x.lineWidth=1.5;for(let i=0;i<256;i+=5){x.beginPath();x.moveTo(i,y);x.lineTo(i+2,y+h);x.stroke();}}
        else if(m<.7){x.fillStyle='rgba(255,255,255,.14)';for(let j=y+8;j<y+h;j+=14)x.fillRect(0,j,256,5);}
        const g=x.createLinearGradient(0,y,0,y+h);
        g.addColorStop(0,'rgba(255,255,255,.22)');g.addColorStop(.22,'rgba(255,255,255,0)');g.addColorStop(.78,'rgba(0,0,0,0)');g.addColorStop(1,'rgba(0,0,0,.45)');
        x.fillStyle=g;x.fillRect(0,y,256,h);y+=h;
      }
    });
  }
  const texA=fabric(7,['#1c1b19','#d6ccbc','#8e8a83','#f2efe9','#3a3936']);
  const texB=fabric(31,['#e9e4da','#b9ae9c','#2a2927','#cfc8bc']);
  const texC=fabric(97,['#f7f6f3','#8e8a83','#0f0f0e','#d6ccbc']);

  /* printed bag film: rounded top corners, zip strip, diagonal seam with ticks, dark size label */
  function bagFace(letter,w,h,front){
    const W=512,H=Math.round(512*h/w);
    return canvasTex(W,H,(x)=>{
      const r=W*.09;
      x.save();x.beginPath();x.moveTo(0,H);x.lineTo(0,r);x.quadraticCurveTo(0,0,r,0);x.lineTo(W-r,0);x.quadraticCurveTo(W,0,W,r);x.lineTo(W,H);x.closePath();x.clip();
      x.fillStyle='rgba(128,128,125,.9)';x.fillRect(0,0,W,H);
      const sheen=x.createLinearGradient(0,0,W,H);sheen.addColorStop(0,'rgba(255,255,255,.10)');sheen.addColorStop(.5,'rgba(255,255,255,0)');sheen.addColorStop(1,'rgba(0,0,0,.06)');
      x.fillStyle=sheen;x.fillRect(0,0,W,H);
      x.fillStyle='rgba(70,70,68,.95)';x.fillRect(0,H*.03,W,H*.02);
      x.fillStyle='rgba(40,40,39,.6)';x.fillRect(0,H*.058,W,2);
      x.fillStyle='rgba(60,60,58,.85)';
      for(let k=0;k<3;k++)x.fillRect(0,H-H*.03-k*H*.016,W,3);
      if(front){
        const x0=W*.07,y0=H*.93,x1=W*.95,y1=H*.08;
        const ang=Math.atan2(y1-y0,x1-x0),len=Math.hypot(x1-x0,y1-y0);
        x.strokeStyle='rgba(25,25,24,.9)';x.lineWidth=3;x.beginPath();x.moveTo(x0,y0);x.lineTo(x1,y1);x.stroke();
        x.translate(x0,y0);x.rotate(ang);
        x.lineWidth=2;x.strokeStyle='rgba(25,25,24,.75)';
        for(let d=len*.06;d<len*.95;d+=len*.03){const tl=(Math.round(d/(len*.03))%5===0)?12:6;x.beginPath();x.moveTo(d,0);x.lineTo(d,tl);x.stroke();}
        const bs=len*.42,bl=len*.46,bh=W*.12;
        x.fillStyle='#2a2a29';
        x.beginPath();x.moveTo(bs,0);x.lineTo(bs+bl-bh*.5,0);x.quadraticCurveTo(bs+bl,0,bs+bl,bh*.5);x.lineTo(bs+bl,bh);x.lineTo(bs+bh*.2,bh);x.quadraticCurveTo(bs-bh*.25,bh*.5,bs,0);x.fill();
        x.textBaseline='middle';
        x.fillStyle='#f07a1a';x.font='700 '+Math.round(bh*.78)+'px "Inter Tight", Arial, sans-serif';
        x.fillText(letter,bs+bh*.25,bh*.54);
        const tx=bs+bh*.25+bh*.62;
        x.fillStyle='#f2f2f0';x.font='500 '+Math.round(bh*.21)+'px "Inter Tight", Arial, sans-serif';
        x.fillText('TRAVEL SET PACKAGE',tx,bh*.33);
        x.fillStyle='#f07a1a';x.font='600 '+Math.round(bh*.27)+'px "Inter Tight", Arial, sans-serif';
        x.fillText('VACUUM  STORAGE  BAG',tx,bh*.68);
      }
      x.restore();
    });
  }

  /* pillow-shaped vacuum bag: two printed films sealed at the edges, clothes inside */
  function makeBag(w,h,D,cloth,letter){
    const g=new THREE.Group();
    const wi=w*.86,hi=h*.78,oy=-h*.05;
    const gF=new THREE.PlaneGeometry(w,h,44,60);
    const gB=new THREE.PlaneGeometry(w,h,44,60);gB.rotateY(Math.PI);
    const gIn=new THREE.BoxGeometry(wi,hi,1,34,46,1);
    const bF=gF.attributes.position.array.slice(),bB=gB.attributes.position.array.slice(),bIn=gIn.attributes.position.array.slice();
    const film=t=>new THREE.MeshPhysicalMaterial({map:t,transparent:true,roughness:.32,metalness:0,clearcoat:.8,clearcoatRoughness:.15,depthWrite:false});
    const inner=new THREE.Mesh(gIn,new THREE.MeshStandardMaterial({map:cloth,roughness:.92}));inner.position.y=oy;
    const back=new THREE.Mesh(gB,film(bagFace(letter,w,h,false)));back.renderOrder=1;
    const front=new THREE.Mesh(gF,film(bagFace(letter,w,h,true)));front.renderOrder=2;
    const valve=new THREE.Group();
    const vr=Math.min(w,h)*.075;
    const base=new THREE.Mesh(new THREE.CylinderGeometry(vr,vr*1.06,.03,48),new THREE.MeshStandardMaterial({color:C('#4a4a48'),roughness:.4}));base.rotation.x=Math.PI/2;
    const rimV=new THREE.Mesh(new THREE.TorusGeometry(vr*.72,vr*.09,12,48),new THREE.MeshStandardMaterial({color:C('#9a9a97'),roughness:.3,metalness:.3}));rimV.position.z=.02;
    const zipMat=new THREE.MeshStandardMaterial({color:C('#222221'),roughness:.35,emissive:new THREE.Color(0xffffff),emissiveIntensity:0});
    const cap=new THREE.Mesh(new THREE.CylinderGeometry(vr*.6,vr*.6,.045,40),zipMat);cap.rotation.x=Math.PI/2;cap.position.z=.02;
    valve.add(base,rimV,cap);
    const vy=h*.24;valve.position.y=vy;
    g.add(inner,back,front,valve);
    const A=Math.min(w,h)*.035;
    const noise=(x,y)=>Math.sin(x*4.1+y*1.3)*Math.cos(y*3.3-x*.9)+.55*Math.sin(x*9.7+y*7.1)*Math.sin(y*5.9-x*3.6);
    const prof=(x,y,W,H)=>{const nx=x/(W/2),ny=y/(H/2);return Math.sqrt(Math.max(0,1-nx*nx*nx*nx)*Math.max(0,1-ny*ny*ny*ny));};
    function film3(geo,b,s,puff,wr){
      const p=geo.attributes.position.array;
      for(let i=0;i<p.length;i+=3){
        const x=b[i],y=b[i+1],nx=x/(w/2),ny=y/(h/2),pr=prof(x,y,w,h);
        p[i]=x*(1-.05*puff*(1-ny*ny));p[i+1]=y*(1-.035*puff*(1-nx*nx));
        p[i+2]=s*(.03*Math.pow(pr,.25)+D*puff*pr)+wr*A*noise(x,y)*pr;
      }
      geo.attributes.position.needsUpdate=true;geo.computeVertexNormals();
    }
    function fill3(puff,wr){
      const p=gIn.attributes.position.array;
      for(let i=0;i<p.length;i+=3){
        const x=bIn[i],y=bIn[i+1],s=bIn[i+2]>0?1:-1,nx=x/(wi/2),ny=y/(hi/2);
        p[i]=x*(1-.05*puff*(1-ny*ny));p[i+1]=y*(1-.035*puff*(1-nx*nx));
        p[i+2]=s*(.012+D*.84*puff*prof(x,y,wi,hi))+wr*A*noise(x,y+oy)*prof(x,y+oy,w,h);
      }
      gIn.attributes.position.needsUpdate=true;gIn.computeVertexNormals();
    }
    const st={puff:-1,wr:-1};
    g.userData={vy,zipMat,
      update(puff,wr){
        if(Math.abs(puff-st.puff)<.0005&&Math.abs(wr-st.wr)<.0005)return;
        st.puff=puff;st.wr=wr;
        film3(gF,bF,1,puff,wr);film3(gB,bB,-1,puff,wr);fill3(puff,wr);
        const pr=prof(0,vy,w,h);
        valve.position.z=.03*Math.pow(pr,.25)+D*puff*pr+wr*A*noise(0,vy)*pr+.012;
      },
      valveZ(){return valve.position.z;}
    };
    g.userData.update(1,0);
    return g;
  }

  /* rechargeable pump: slim black body, front button, LED dots, ribbed grip, collar, white nozzle cap (nozzle at the bottom) */
  const ribTex=canvasTex(512,64,(x,W,H)=>{x.fillStyle='#161616';x.fillRect(0,0,W,H);for(let i=0;i<W;i+=8){x.fillStyle='#0a0a0a';x.fillRect(i,0,3,H);x.fillStyle='#262626';x.fillRect(i+3,0,1,H);}});
  ribTex.wrapS=THREE.RepeatWrapping;
  const capTex=canvasTex(512,64,(x,W,H)=>{x.fillStyle='#ecebe8';x.fillRect(0,0,W,H);for(let i=0;i<W;i+=10){x.fillStyle='#cfcdc8';x.fillRect(i,0,2,H);}});
  function makePump(){
    const g=new THREE.Group();
    const V=a=>a.map(p=>new THREE.Vector2(p[0],p[1]));
    const black=new THREE.MeshPhysicalMaterial({color:C('#141414'),roughness:.5,clearcoat:.3,clearcoatRoughness:.45});
    const body=new THREE.Mesh(new THREE.LatheGeometry(V([[0,-.4],[.212,-.4],[.212,.74],[.204,.775],[.185,.795],[.15,.8],[0,.8]]),72),black);
    const ribs=new THREE.Mesh(new THREE.CylinderGeometry(.2145,.2145,.6,72,1,true),new THREE.MeshStandardMaterial({map:ribTex,roughness:.7}));ribs.position.y=-.08;
    const collar=new THREE.Mesh(new THREE.LatheGeometry(V([[0,-.62],[.258,-.62],[.272,-.6],[.274,-.45],[.262,-.41],[.215,-.395],[0,-.395]]),72),
      new THREE.MeshPhysicalMaterial({color:C('#0e0e0e'),roughness:.35,clearcoat:.6,clearcoatRoughness:.25}));
    const nozzleCap=new THREE.Mesh(new THREE.CylinderGeometry(.262,.262,.15,72),[new THREE.MeshStandardMaterial({map:capTex,roughness:.45}),new THREE.MeshStandardMaterial({color:C('#ecebe8'),roughness:.45}),new THREE.MeshStandardMaterial({color:C('#dcdad5'),roughness:.45})]);
    nozzleCap.position.y=-.695;
    const tip=new THREE.Mesh(new THREE.CylinderGeometry(.09,.075,.08,40),new THREE.MeshStandardMaterial({color:C('#bdbbb6'),roughness:.4,metalness:.2}));tip.position.y=-.81;
    const btnRing=new THREE.Mesh(new THREE.TorusGeometry(.078,.01,10,40),new THREE.MeshStandardMaterial({color:C('#2a2a2a'),roughness:.4}));btnRing.position.set(0,.5,.208);
    const btn=new THREE.Mesh(new THREE.SphereGeometry(.072,32,16),new THREE.MeshStandardMaterial({color:C('#d9d8d4'),roughness:.35}));btn.scale.z=.32;btn.position.set(0,.5,.205);
    const port=new THREE.Mesh(new THREE.BoxGeometry(.1,.012,.032),new THREE.MeshStandardMaterial({color:C('#050505'),roughness:.6}));port.position.set(0,.797,.05);
    const ledMat=new THREE.MeshStandardMaterial({color:0x333333,emissive:new THREE.Color(0xf7f6f3),emissiveIntensity:.6});
    for(let i=0;i<4;i++){const l=new THREE.Mesh(new THREE.SphereGeometry(.011,12,12),ledMat);l.position.set(0,.3-i*.045,.211);g.add(l);}
    g.add(body,ribs,collar,nozzleCap,tip,btnRing,btn,port);
    g.userData.led=ledMat;
    return g;
  }

  /* --- chapter 1+2: hero bag + exhale (large bag, 54 x 74 cm ratio) --- */
  const bagRig=new THREE.Group();scene.add(bagRig);
  const bag=makeBag(2.19,3.0,.6,texA,'L');bagRig.add(bag);
  const pumpA=makePump();pumpA.scale.setScalar(.72);bag.add(pumpA);pumpA.visible=false;
  const N=320,pPos=new Float32Array(N*3),pSeed=[];
  for(let i=0;i<N;i++)pSeed.push([Math.random(),Math.random()*TAU,.3+Math.random()*.9]);
  const pGeo=new THREE.BufferGeometry();pGeo.setAttribute('position',new THREE.BufferAttribute(pPos,3));
  const pMat=new THREE.PointsMaterial({color:0xf7f6f3,size:.035,transparent:true,opacity:0,depthWrite:false});
  const air=new THREE.Points(pGeo,pMat);bag.add(air);

  /* --- chapter 3: kit ring, real size ratios --- */
  const kit=new THREE.Group();scene.add(kit);
  const ring=new THREE.Group();kit.add(ring);
  const sizes=[[1.17,1.6,.32,texA,'L'],[1.17,1.6,.32,texC,'L'],[1.02,1.38,.28,texB,'M'],[1.02,1.38,.28,texA,'M'],[.87,1.17,.24,texC,'S'],[.87,1.17,.24,texB,'S']];
  const kitItems=sizes.map((s,i)=>{const b=makeBag(s[0],s[1],s[2],s[3],s[4]);b.userData.update(.5+(i%2)*.12,.35);return b;});
  const pumpK=makePump();pumpK.scale.setScalar(.95);kitItems.push(pumpK);
  const R=2.7;
  kitItems.forEach((it,i)=>{const a=i/7*TAU;const holder=new THREE.Group();holder.position.set(Math.sin(a)*R,0,Math.cos(a)*R);holder.rotation.y=a;holder.add(it);ring.add(holder);});
  const floor=new THREE.Mesh(new THREE.RingGeometry(R-.02,R+.02,128),new THREE.MeshBasicMaterial({color:0x0b0b0a,transparent:true,opacity:.18,side:THREE.DoubleSide}));
  floor.rotation.x=-Math.PI/2;floor.position.y=-1.05;kit.add(floor);
  kit.position.y=-.35;kit.rotation.x=.16;

  /* --- chapter 4: hero pump --- */
  const pumpRig=new THREE.Group();scene.add(pumpRig);
  const pumpB=makePump();pumpRig.add(pumpB);
  const halo=new THREE.Mesh(new THREE.TorusGeometry(1.25,.004,8,180),new THREE.MeshBasicMaterial({color:0xd6ccbc,transparent:true,opacity:.3}));
  const halo2=new THREE.Mesh(new THREE.TorusGeometry(1.5,.003,8,180),new THREE.MeshBasicMaterial({color:0x8e8a83,transparent:true,opacity:.2}));
  pumpRig.add(halo,halo2);

  if(document.fonts&&document.fonts.load){Promise.all([document.fonts.load('700 40px "Inter Tight"'),document.fonts.load('500 40px "Inter Tight"'),document.fonts.load('600 40px "Inter Tight"')]).then(()=>redraws.forEach(f=>f())).catch(()=>{});}

  const startMobile=innerWidth/innerHeight<.8;
  const groups={bag:{o:bagRig,s:startMobile?0:1},kit:{o:kit,s:0},pump:{o:pumpRig,s:0}};
  kit.scale.setScalar(.001);pumpRig.scale.setScalar(.001);if(startMobile)bagRig.scale.setScalar(.001);

  function resize(){const w=innerWidth,h=innerHeight;renderer.setSize(w,h,false);camera.aspect=w/h;camera.position.z=w/h<.8?13:9;camera.updateProjectionMatrix();}
  addEventListener('resize',resize);resize();

  let ptr={x:0,y:0},ptrS={x:0,y:0};
  addEventListener('pointermove',e=>{ptr.x=e.clientX/innerWidth*2-1;ptr.y=e.clientY/innerHeight*2-1;});

  const glSecs=[...document.querySelectorAll('.gl')];
  const chSecs=[...document.querySelectorAll('[data-ch]')];
  let rot={bx:0,by:-.4,ky:0,py:0},lastIdx=-1,lastStep=-1;
  const kitInfo=[
    ['Large bag','54 × 74 cm · 21 × 29 in','Puffers, hoodies, knits. Sized for a 28-inch suitcase.'],
    ['Large bag','54 × 74 cm · 21 × 29 in','The second large. One for the outbound, one for the way home.'],
    ['Medium bag','47 × 64 cm · 18.5 × 25 in','Jeans and a week of tees. Sized for a 24-inch case.'],
    ['Medium bag','47 × 64 cm · 18.5 × 25 in','Shirts and dresses you want flat, not rolled.'],
    ['Small bag','40 × 54 cm · 16 × 21 in','Socks, underwear, swimwear. Sized for a 20-inch carry-on.'],
    ['Small bag','40 × 54 cm · 16 × 21 in','Gym kit, scarves, a spare set.'],
    ['Rechargeable pump','Fits all six bags','Sits on each valve and pulls the air out. No hand-rolling.']
  ];
  const steps=[...document.querySelectorAll('#steps li')],dots=[...document.querySelectorAll('#kitDots li')];
  const clock=new THREE.Clock();

  tick3d=()=>{
    const t=clock.getElapsedTime();
    const vh=innerHeight,mid=vh*.5,mobile=innerWidth/innerHeight<.8;
    let ch='flat';
    for(const el of chSecs){const r=el.getBoundingClientRect();if(r.top<=mid&&r.bottom>mid){ch=el.dataset.ch;break;}}
    const visible=glSecs.some(el=>{const r=el.getBoundingClientRect();return r.bottom>0&&r.top<vh;});

    ptrS.x+=(ptr.x-ptrS.x)*.05;ptrS.y+=(ptr.y-ptrS.y)*.05;
    const idle=reduce?0:t;

    const tg={bag:0,kit:0,pump:0};
    if(ch!=='flat')tg[ch]=1;else{tg.bag=groups.bag.s>.5?1:0;tg.kit=groups.kit.s>.5?1:0;tg.pump=groups.pump.s>.5?1:0;}
    /* phones: the hero copy fills the screen, so the bag waits for the exhale chapter */
    if(mobile&&$('#exhale').getBoundingClientRect().top>vh*.6)tg.bag=0;
    for(const k in groups){const G=groups[k];G.s+=(tg[k]-G.s)*.09;G.o.visible=G.s>.01;}
    scene.background.lerp(ch==='kit'?bgBone:bgInk,.08);

    /* bag: hero + exhale */
    const exP=progress($('#exhale'));
    const inHero=$('#exhale').getBoundingClientRect().top>mid;
    let puff=1,wr=0,pumping=0,fly=0,tx,ty,ts,tRy,tRx;
    if(inHero){
      const asp=innerWidth/innerHeight,halfW=Math.tan(17.5*Math.PI/180)*camera.position.z*asp;
      tx=mobile?0:halfW*.6;ty=mobile?-2.2:-.05;ts=mobile?.62:clamp(asp/1.7,.72,1);
      tRy=-.45+Math.sin(idle*.45)*.35+ptrS.x*.35;tRx=.12+ptrS.y*.12;
    }else{
      const p=exP;
      puff=p<.3?1:1-ease(seg(p,.3,.78))*.9;
      wr=1-puff;
      pumping=seg(p,.3,.35)*(1-seg(p,.76,.8));
      fly=ease(seg(p,.16,.3))*(1-ease(seg(p,.84,.95)));
      tx=mobile?0:.55;ty=mobile?-.35:-.1;ts=mobile?.68:1;
      tRy=p*TAU;tRx=.1+Math.sin(p*TAU)*.12+ptrS.y*.05;
      const step=p<.28?0:p<.8?1:2;
      if(step!==lastStep){lastStep=step;steps.forEach((li,i)=>li.classList.toggle('on',i===step));}
      const out=Math.round(clamp((1-puff)/.9)*100);
      $('#airVal').textContent=out;$('#airBar').style.width=out+'%';
      $('#rotVal').textContent='ROTATION '+String(Math.round(p*360)).padStart(3,'0')+'°';
      bag.userData.zipMat.emissiveIntensity=Math.sin(seg(p,.86,.96)*Math.PI)*.9;
    }
    bag.userData.update(puff,wr);
    bagRig.position.x+=(tx-bagRig.position.x)*.08;bagRig.position.y+=(ty-bagRig.position.y)*.08;
    bagRig.scale.setScalar(Math.max(.001,groups.bag.s*ts));
    rot.by+=(tRy-rot.by)*.1;rot.bx+=(tRx-rot.bx)*.1;
    bag.rotation.set(rot.bx,rot.by,0);
    bag.position.y=reduce?0:Math.sin(t*1.1)*.05;

    /* pump drops onto the valve, nozzle first */
    pumpA.visible=fly>.002;
    if(pumpA.visible){
      const s=.72,vz=bag.userData.valveZ(),az=vz+.85*s,vy=bag.userData.vy;
      pumpA.position.set(lerp(2.4,0,fly)+(reduce?0:Math.sin(t*70)*.006*pumping),lerp(vy+1.6,vy,fly),lerp(az+2.2,az,fly));
      pumpA.rotation.set(Math.PI/2-(1-fly)*1.1,0,(1-fly)*-.9);
      pumpA.userData.led.emissiveIntensity=.3+pumping*(.7+.5*Math.sin(t*9));
      const b=pumpA.position,ez=b.z+.8*s;
      for(let i=0;i<N;i++){
        const [ph,th,sp]=pSeed[i];const u=((reduce?0:t)*.55*sp+ph)%1;
        const rr=.04+u*1.1*sp;
        pPos[i*3]=b.x+Math.cos(th)*rr;pPos[i*3+1]=b.y+Math.sin(th)*rr;pPos[i*3+2]=ez+u*3.4;
      }
      pGeo.attributes.position.needsUpdate=true;
      pMat.opacity=pumping*.7;
    }else pMat.opacity=0;
    air.visible=pMat.opacity>.01;

    /* kit ring: one full 360 across the chapter */
    const kP=progress($('#kit'));
    rot.ky+=(-kP*TAU-rot.ky)*.1;
    ring.rotation.y=rot.ky;
    kit.scale.setScalar(Math.max(.001,groups.kit.s*(mobile?.62:1)));
    kit.position.x=mobile?0:.6;
    kitItems.forEach((it,i)=>{it.rotation.y=reduce?0:Math.sin(t*.7+i)*.18;it.position.y=reduce?0:Math.sin(t*1.2+i*.9)*.06;});
    const idx=((Math.round(kP*7)%7)+7)%7;
    if(idx!==lastIdx){lastIdx=idx;$('#kitIdx').textContent=String(idx+1).padStart(2,'0')+' / 07';$('#kitName').textContent=kitInfo[idx][0];$('#kitDim').textContent=kitInfo[idx][1];$('#kitDesc').textContent=kitInfo[idx][2];dots.forEach((d,i)=>d.classList.toggle('on',i===idx));}

    /* hero pump */
    const pP=progress($('#pump'));
    rot.py+=(pP*TAU+.5+ptrS.x*.3-rot.py)*.1;
    pumpB.rotation.set(Math.sin(pP*TAU)*.3+ptrS.y*.1,rot.py,Math.sin(pP*Math.PI)*.4);
    pumpRig.scale.setScalar(Math.max(.001,groups.pump.s*(mobile?1.2:1.6)));
    pumpRig.position.y=mobile?.35:-.05;
    halo.rotation.set(Math.PI/2+.3,pP*TAU*.5,0);halo2.rotation.set(Math.PI/2-.25,-pP*TAU*.7,.2);
    pumpB.userData.led.emissiveIntensity=.4+.4*Math.sin(t*3);
    ['c1','c2','c3'].forEach((id,i)=>{const on=mobile?(pP>=i/3&&(i===2||pP<(i+1)/3)):pP>.12+i*.22;$('#'+id).classList.toggle('on',on);});
    $('#pumpDeg').textContent='ROTATION '+String(Math.round(pP*360)).padStart(3,'0')+'°';

    if(visible)renderer.render(scene,camera);
  };
}

function frame(){updateType();updateCase();updateSet();tick3d();requestAnimationFrame(frame);}
requestAnimationFrame(frame);
})();
